/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import classnames from 'classnames';
import { dropdownCaret } from 'assets/images';
import { FiChevronDown } from 'react-icons/fi';
import { ToolTipPopper } from 'components';

const DropDown = props => {
  const {
    customClassName,
    customParentClassName,
    options,
    selectedOption,
    labelText,
    rounded,
    small,
    sm,
    id,
    error,
    name,
    noOptionsMessage,
    placeholder,
    isLoading,
    isDisabled,
    altCaret,
    handleOnChange,
    toolTipDetails,
    showInPopup,
  } = props;

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <div className="d-flex">
          {altCaret ? <FiChevronDown /> : <img src={dropdownCaret} className="color-black-base" alt="dropdown-caret" />}
        </div>
      </components.DropdownIndicator>
    );
  };

  const NoOptionsMessage = props => {
    return (
      <components.NoOptionsMessage {...props}>
        <p>{noOptionsMessage}</p>
      </components.NoOptionsMessage>
    );
  };

  const Option = props => {
    return (
      <div>
        <components.Option {...props}>
          <p>{props.data.label}</p>
          {props.data.description && <p className="dropdown-label">{props.data.description}</p>}
        </components.Option>
      </div>
    );
  };

  return (
    <div
      className={`custom-dropdown custom-dropdown-dt ${showInPopup ? 'dropdownInPopup' : ''} ${customParentClassName} ${
        sm ? 'lf-select--sm__wrapper' : ''
      }`}
    >
      {labelText !== '' && (
        <div style={{ display: 'flex' }}>
          <label style={{ display: 'inline - block' }} htmlFor={id} className="lf-input__label required">
            {labelText}
          </label>
          {toolTipDetails || toolTipDetails === '' ? (
            <ToolTipPopper placement="top-start" trigger="click" tooltip={toolTipDetails} />
          ) : (
            ''
          )}
        </div>
      )}

      <Select
        id={id}
        maxMenuHeight={190}
        name={name}
        placeholder={placeholder || 'Select...'}
        value={selectedOption && selectedOption.label ? selectedOption : null} // if selectedOption has default value (i.e. => {}),it should be made null to display placehoolder in the dropdown
        onChange={handleOnChange}
        classNamePrefix="lf-select"
        className={classnames(
          'lf-select',
          {
            'lf-select--rounded': rounded,
            'lf-select--small': small,
            'lf-select--sm': sm,
            'lf-select--error': error,
          },
          customClassName
        )}
        options={options}
        components={{ DropdownIndicator, NoOptionsMessage, Option }}
        isLoading={isLoading}
        isDisabled={isDisabled}
      />

      {error !== '' && <p className="lf-input__helper">{error}</p>}
    </div>
  );
};

DropDown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  customClassName: PropTypes.string,
  handleOnChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.object,
  labelText: PropTypes.string,
  rounded: PropTypes.bool,
  small: PropTypes.bool,
  sm: PropTypes.bool,
  id: PropTypes.string,
  error: PropTypes.string,
  name: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  maxMenuHeight: PropTypes.number,
  placeholder: PropTypes.string,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  altCaret: PropTypes.bool,
  toolTipDetails: PropTypes.string,
  showInPopup: PropTypes.bool,
  customParentClassName: PropTypes.string,
};

DropDown.defaultProps = {
  options: [{}],
  customClassName: '',
  selectedOption: {},
  labelText: '',
  rounded: false,
  small: false,
  sm: false,
  id: '',
  error: '',
  name: '',
  noOptionsMessage: 'no option',
  maxMenuHeight: 250,
  isLoading: false,
  isDisabled: false,
};

export default DropDown;
